import React from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const BoxIcon = styled('span')({
  width: 16,
  height: 16,
  borderRadius: 4,
  border: '1px solid var(--color-border)',
  backgroundColor: 'var(--color-surface)',
  display: 'inline-block',
  boxSizing: 'border-box',
});

const CheckedIcon = styled(BoxIcon)({
  backgroundColor: '#1C6CD6',
  borderColor: '#1C6CD6',
  position: 'relative',

  '&:after': {
    content: '""',
    position: 'absolute',
    left: 4,
    top: 2,
    width: 6,
    height: 8,
    border: '2px solid #fff',
    borderTop: 0,
    borderLeft: 0,
    transform: 'rotate(45deg)',
  },
});

const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  gap: 12,
  alignItems: 'center',
});

const Checkbox = (props) => {
  const {
    label,
    labelPlacement = 'end',
    typographyProps,
    ...checkboxProps
  } = props;
  return (
    <StyledFormControlLabel
      labelPlacement={labelPlacement}
      control={
        <MuiCheckbox
          disableRipple
          icon={<BoxIcon />}
          checkedIcon={<CheckedIcon />}
          sx={{ padding: 0 }}
          {...checkboxProps}
        />
      }
      label={
        <Typography
          sx={{ fontSize: 14, color: 'var(--color-text-primary)' }}
          {...typographyProps}
        >
          {label}
        </Typography>
      }
    />
  );
};

export default Checkbox;
